import Home from '@/views/ground/home/Home.vue'
import MyTeam from '@/views/ground/myteam/MyTeam.vue'
import Team from '@/views/ground/team/Team.vue'
import Molecule from '@/views/ground/molecule/Molecule.vue'
import MC from '@/views/ground/mc/MC.vue'
import MapOfLife from '@/views/ground/mapOfLife/MapOfLife.vue' 
import Captains from '@/views/ground/captains/Captains.vue' 

import MapOfCareers from '@/views/ground/mapOfCareers/MapOfCareers.vue' 
import JobsOccupations from '@/views/ground/mapOfCareers/JobsOccupations.vue'
import BestUniversities from '@/views/ground/mapOfCareers/BestUniversities.vue'
import BestUniversity from '@/views/ground/mapOfCareers/BestUniversity.vue'
import BestJobs from '@/views/ground/mapOfCareers/BestJobs.vue'
import BestJob from '@/views/ground/mapOfCareers/BestJob.vue'

import JobsByCategory from '@/views/ground/mapOfCareers/JobsByCategory.vue'
import ProfessionsOfFuture from '@/views/ground/mapOfCareers/jobsByCategory/ProfessionsOfFuture.vue'
import ProfessionOfFuture from '@/views/ground/mapOfCareers/jobsByCategory/ProfessionOfFuture.vue'

import Mytop3 from '@/views/ground/mytop3/Mytop3'

import Planner from '@/views/ground/planner/Planner'
import EditPlanner from '@/views/ground/planner/Edit'


import MyGroup from '@/views/ground/mygroup/MyGroup.vue'
import MyProfile from '@/views/ground/myprofile/MyProfile.vue'
import Profile from '@/views/ground/profile/Profile.vue'
import Awards from '@/views/ground/awards/Awards.vue'

import MyCaptainProfile from '@/views/ground/captain/MyCaptainProfile.vue'
import CaptainProfile from '@/views/ground/captain/CaptainProfile.vue'

import Articles from '@/views/ground/articles/Articles.vue'
import Videos from '@/views/ground/videos/Videos.vue'
import VideoSection from '@/views/ground/videos/VideoSection.vue'

import A_Users from '@/views/admin/users/Users.vue'
import Payments from '@/views/admin/payments/Payments.vue'

import A_Videos from '@/views/admin/videos/Videos.vue'
import A_VideosAdd from '@/views/admin/videos/Add.vue'

import A_Articles from '@/views/admin/articles/Articles.vue'
import A_ArticlesAdd from '@/views/admin/articles/Add.vue'
import A_ArticlesEdit from '@/views/admin/articles/Edit.vue'

import A_Groups from '@/views/admin/groups/Groups.vue'
import A_GroupsCenter from '@/views/admin/groups/GroupsCenter.vue'
import A_GroupsAdd from '@/views/admin/groups/Add.vue'
import A_Group from '@/views/admin/groups/Group.vue'

import A_Teams from '@/views/admin/teams/Teams.vue'
import A_TeamsAdd from '@/views/admin/teams/Add.vue'
import A_TeamsEdit from '@/views/admin/teams/Edit.vue'
import A_Team from '@/views/admin/teams/Team.vue'

import A_Schedules from '@/views/admin/schedules/Schedules.vue'
import A_SchedulesAdd from '@/views/admin/schedules/Add.vue'
import A_Centers from '@/views/admin/centers/Centers.vue'
import A_CentersAdd from '@/views/admin/centers/Add.vue'
import A_Center from '@/views/admin/centers/Center.vue'

import A_Sessions from '@/views/admin/sessions/Sessions.vue'
import A_SessionsSet from '@/views/admin/sessions/Set.vue'

import Account from '@/views/personal/account/Account.vue'

import ToDo from '@/views/ground/home/ToDo.vue'
import ToLearn from '@/views/ground/home/ToLearn.vue'
import Personal from '@/views/ground/home/Personal.vue'

import HowTo from '@/views/ground/howTo/HowTo.vue'
import VideoLibrary from '@/views/ground/videoLibrary/VideoLibrary.vue'

export default {
    get() {
        let routes = [
            {
                path: '/program-application',
                name: 'programApplication',
                component: () => import('@/views/public/ProgramApplication.vue'),
                meta: { isProcessToSign: true, layout: 'outsider', isPublic: true }
            },
            {
                path: '/summercamp-application',
                name: 'summercampApplication',
                component: () => import('@/views/public/SummercampApplication.vue'),
                meta: { isProcessToSign: true, layout: 'outsider', isPublic: true }
            },
            {
                path: '/login',
                name: 'login',
                component: () => import('@/views/public/Login.vue'),
                meta: { isProcessToSign: true, layout: 'outsider', isPublic: true }
            },
            // {
            //     path: '/signup',
            //     name: 'signup',
            //     component: () => import('@/views/public/Signup.vue'),
            //     meta: { isProcessToSign: true, layout: 'outsider', isPublic: true }
            // },
            {
                path: '/lostpassword',
                name: 'lostpassword',
                component: () => import('@/views/public/LostPassword.vue'),
                meta: { isProcessToSign: true, layout: 'outsider', isPublic: true }
            },
            {
                path: '/privacy',
                name: 'legalprivacy',
                component: () => import('@/views/public/LegalPrivacy.vue'),
                meta: { isProcessToSign: true, layout: 'outsider', isPublic: true }
            },
            {
                path: '/terms-and-conditions',
                name: 'legalterms',
                component: () => import('@/views/public/LegalTerms.vue'),
                meta: { isProcessToSign: true, layout: 'outsider', isPublic: true }
            },
            // ------------------------------------------------------------------------------------------------
            // SUCCESS
            // {
            //     path: '/cart/success-livestream',
            //     name: 'successLivestream',
            //     component: () => import('@/views/public/cart/SuccessLivestream.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            {
                path: '/cart/success-program-application',
                name: 'successProgramApplication',
                component: () => import('@/views/public/cart/SuccessProgramApplication.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            // {
            //     path: '/cart/success-program-module1',
            //     name: 'successProgramModule1',
            //     component: () => import('@/views/public/cart/SuccessProgramModule1.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            // {
            //     path: '/cart/success-program-module2',
            //     name: 'successProgramModule2',
            //     component: () => import('@/views/public/cart/SuccessProgramModule2.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            {
                path: '/cart/success-summercamp-application',
                name: 'successSummercampApplication',
                component: () => import('@/views/public/cart/SuccessSummercampApplication.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            // {
            //     path: '/cart/success-summercamp',
            //     name: 'successSummercamp',
            //     component: () => import('@/views/public/cart/SuccessSummercamp.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            {
                path: '/cart/success-subscription/:id',
                component: () => import('@/views/public/cart/SuccessSubscription.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            // ------------------------------------------------------------------------------------------------
            // CART
            {
                path: '/cart',
                name: 'cart',
                component: () => import('@/views/public/cart/Cart.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            // {
            //     path: '/cart/livestream',
            //     name: 'cartLivestream',
            //     component: () => import('@/views/public/cart/Livestream.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            {
                path: '/cart/program-application',
                name: 'cartProgramApplication',
                component: () => import('@/views/public/cart/ProgramApplication.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            // {
            //     path: '/cart/program-module1',
            //     name: 'cartProgramModule1',
            //     component: () => import('@/views/public/cart/ProgramModule1.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            // {
            //     path: '/cart/program-module2',
            //     name: 'cartProgramModule2',
            //     component: () => import('@/views/public/cart/ProgramModule2.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            {
                path: '/cart/summercamp-application',
                name: 'cartSummercampApplication',
                component: () => import('@/views/public/cart/SummercampApplication.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            // {
            //     path: '/cart/summercamp',
            //     name: 'cartSummercamp',
            //     component: () => import('@/views/public/cart/Summercamp.vue'),
            //     meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            // },
            {
                path: '/subscription',
                component: () => import('@/views/public/cart/Subscription.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            {
                path: '/checkout/:id',
                component: () => import('@/views/public/cart/Checkout.vue'),
                meta: { isProcessToSign: false, layout: 'producter', isPublic: true }
            },
            // GROUND ---
            {
                path: '/home',
                name: 'home',
                component: Home
            },
            {
                path: '/my-profile',
                name: 'myprofile',
                component: MyProfile,
            },
            {
                path: '/profile/:id',
                name: 'profile',
                component: Profile
            },
            // CAPTAIN PROFILES
            {
                path: '/my-captain-profile',
                component: MyCaptainProfile,
            },
            {
                path: '/captain-profile/:id',
                component: CaptainProfile,
                meta: {
                    allowed: {
                        captain: true
                    }
                }
            },
            {
                path: '/molecule',
                name: 'molecule',
                component: Molecule,
                // meta: {
                //     allowed: {
                //         student: true
                //     }
                // }
            },
            {
                path: '/planner/p/:id',
                name: 'planner',
                component: Planner
            },
            {
                path: '/planner/edit',
                name: 'editPlanner',
                component: EditPlanner,
                meta: {
                    allowed: {
                        student: true
                    }
                }
            },
            {
                path: '/mc/:id',
                name: 'mc',
                component: MC
            },
            {
                path: '/map-of-life',
                name: 'mapoflife',
                component: MapOfLife
            },
            {
                path: '/map-of-life/:uid',
                name: 'mapoflife',
                component: MapOfLife
            },
            // NEWS
            {
                path: '/to-do',
                component: ToDo
            },
            {
                path: '/to-learn',
                component: ToLearn
            },
            {
                path: '/personal',
                component: Personal
            },
            {
                path: '/how-to',
                component: HowTo
            },
            {
                path: '/video-library',
                component: VideoLibrary
            },
            // ------------------------------------------------------------------------------------------------
            // MAP OF CAREERS
            {
                path: '/map-of-careers',
                name: 'mapOfCareers',
                component: MapOfCareers
            },
            {
                path: '/map-of-careers/jobs-and-occupations',
                name: 'jobsOccupations',
                component: JobsOccupations
            },
            {
                path: '/map-of-careers/best-universities',
                name: 'bestUniversities',
                component: BestUniversities
            },
            {
                path: '/map-of-careers/best-universities/:id',
                name: 'bestUniversity',
                component: BestUniversity
            },
            {
                path: '/map-of-careers/best-jobs',
                name: 'bestJobs',
                component: BestJobs
            },
            {
                path: '/map-of-careers/best-jobs/:id',
                name: 'bestJob',
                component: BestJob
            },
            {
                path: '/map-of-careers/jobs-by-category',
                component: JobsByCategory
            },
            {
                path: '/map-of-careers/jobs-by-category/professions-of-future',
                component: ProfessionsOfFuture
            },
            {
                path: '/map-of-careers/jobs-by-category/professions-of-future/:id',
                component: ProfessionOfFuture
            },
            //
            {
                path: '/my-top3',
                name: 'mytop3',
                component: Mytop3,
                meta: {
                    allowed: {
                        student: true
                    }
                }
            },
            {
                path: '/my-team',
                name: 'myteam',
                component: MyTeam,
                meta: {
                    allowed: {
                        student: true
                    }
                }
            },
            {
                path: '/team/:id',
                name: 'team',
                component: Team
            },
            {
                path: '/my-group',
                name: 'mygroup',
                component: MyGroup,
                meta: {
                    allowed: {
                        student: true
                    }
                }
            },
            {
                path: '/captains',
                name: 'captains',
                component: Captains
            },
            {
                path: '/articles',
                name: 'articles',
                component: Articles
            },
            {
                path: '/videos',
                name: 'videos',
                component: Videos
            },
            {
                path: '/video-section/:id',
                name: 'video-section',
                component: VideoSection
            },
            {
                path: '/awards/',
                name: 'awards',
                component: Awards
            },
            // ADMIN ---
            {
                path: '/admin-payments',
                name: 'a_payments',
                component: Payments,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            {
                path: '/admin-users',
                name: 'a_users',
                component: A_Users,
                meta: {
                    allowed: {
                        master: true,
                        director: true,
                        captain: true
                    }
                }
            },
            {
                path: '/admin-videos',
                name: 'a_videos',
                component: A_Videos,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            {
                path: '/admin-videos/add',
                name: 'a_videosAdd',
                component: A_VideosAdd,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            {
                path: '/admin-articles',
                name: 'a_articles',
                component: A_Articles,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            {
                path: '/admin-articles/add',
                name: 'a_articlesAdd',
                component: A_ArticlesAdd,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            {
                path: '/admin-articles/edit/:id',
                name: 'a_articlesEdit',
                component: A_ArticlesEdit,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            {
                path: '/admin-teams',
                name: 'a_teams',
                component: A_Teams,
                meta: {
                    allowed: {
                        master: true,
                        director: true,
                        captain: true
                    }
                }
            },
            {
                path: '/admin-teams/add',
                name: 'a_teamsAdd',
                component: A_TeamsAdd,
                meta: {
                    allowed: {
                        master: true,
                        director: true
                    }
                }
            },
            {
                path: '/admin-teams/edit/:id',
                name: 'a_teamsEdit',
                component: A_TeamsEdit,
                meta: {
                    allowed: {
                        master: true,
                        director: true
                    }
                }
            },
            {
                path: '/admin-team/:id',
                name: 'a_team',
                component: A_Team,
                meta: {
                    allowed: {
                        master: true,
                        director: true,
                        captain: true
                    }
                }
            },
            {
                path: '/admin-groups',
                name: 'a_groups',
                component: A_Groups,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            {
                path: '/admin-groups-center',
                name: 'a_groupsCenter',
                component: A_GroupsCenter,
                meta: {
                    allowed: {
                        director: true
                    }
                }
            },
            {
                path: '/admin-groups/add',
                name: 'a_groupsAdd',
                component: A_GroupsAdd,
                meta: {
                    allowed: {
                        master: true,
                        director:true
                    }
                }
            },
            {
                path: '/admin-group/:id',
                name: 'a_group',
                component: A_Group,
                meta: {
                    allowed: {
                        master: true,
                        director: true
                    }
                }
            },
            {
                path: '/admin-schedules',
                name: 'a_schedules',
                component: A_Schedules,
                meta: {
                    allowed: {
                        director: true
                    }
                }
            },
            {
                path: '/admin-schedules/add',
                name: 'a_schedulesAdd',
                component: A_SchedulesAdd,
                meta: {
                    allowed: {
                        master:true,
                        director: true
                    }
                }
            },
            {
                path: '/admin-centers',
                name: 'a_centers',
                component: A_Centers,
                meta: {
                    allowed: {
                        master: true,
                    }
                }
            },
            {
                path: '/admin-center/add',
                name: 'a_centersAdd',
                component: A_CentersAdd,
                meta: {
                    allowed: {
                        master: true,
                    }
                }
            },
            {
                path: '/admin-center/:id',
                name: 'a_center',
                component: A_Center,
                meta: {
                    allowed: {
                        master: true,
                    }
                }
            },
            {
                path: '/admin-sessions',
                name: 'a_sessions',
                component: A_Sessions,
                meta: {
                    allowed: {
                        master: true,
                        director: true,
                        captain: true
                    }
                }
            },
            {
                path: '/admin-sessions/set',
                name: 'a_sessionsSet',
                component: A_SessionsSet,
                meta: {
                    allowed: {
                        master: true
                    }
                }
            },
            // PERSONAL ---
            {
                path: '/account',
                name: 'account',
                component: Account,
            },
            // OTHER ROUTES ---
            {
                path: '*', 
                redirect: { name: 'home' } 
            }
        ];

        return routes;
    }
}